<div class="main-content">
  <div class="page-content" cdkScrollable>
    <ng-content #content></ng-content>
  </div>
</div>
